export default {"src":"/_next/static/media/person-outline.e40231f5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};